import { format, getHours, getMinutes, getSeconds, startOfMonth, endOfMonth, subMonths, getDate } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { keySession, keyUserAccess } from '../services/axios';
import {isSafari} from 'react-device-detect';
import dayjs, { Dayjs } from 'dayjs';

export const isAuthenticated = () => {
  if (localStorage.getItem(keySession)) {
    return true
  } else {
    return false
  }
}

export const imgUser = () => {
  var session = localStorage.getItem(keySession);
  if (session !== null) {
    var sesUser = JSON.parse(session);
    return sesUser.picture;
  } else {
    return ""
  }
}

export const GetcompanyId = () => {
  var session = localStorage.getItem(keySession);
  if (session) {
    var sesUser = JSON.parse(session);
    return sesUser.companyId;
  } else {
    return ""
  }
}

export const nameUser = () => {
  var session = localStorage.getItem(keySession);
  if (session) {
    var sesUser = JSON.parse(session);
    return sesUser.name;
  } else {
    return ""
  }
}

export const getAvatar = () => {
  var session = localStorage.getItem(keySession);
  if (session) {
    var sesUser = JSON.parse(session);
    return sesUser.avatar;
  } else {
    return ""
  }
}


export const userAccess = () => {
  var access = localStorage.getItem(keyUserAccess);
  if (access) {
    var userAccess = JSON.parse(access);
    return userAccess;
  } else {
    return ""
  }
}

export const userId = () => {
  var session = localStorage.getItem(keySession);
  if (session) {
    var sesUser = JSON.parse(session);
    return sesUser.personId;
  } else {
    return ""
  }
}

export const GetSessionUser = () => {
  var session = localStorage.getItem(keySession);
  if (session) {
    var sesUser = JSON.parse(session);
    return sesUser;
  } else {
    return ""
  }
}

export const MyData = (date: any) => {
  var result = {
    data: format(date, 'dd/MM/yyyy', { locale: ptBR }),
    diaSemana: format(date, "EEEE", { locale: ptBR }),
    regDate: format(date, "yyyy-MM-dd", { locale: ptBR }),
    hora: '',
    minutos: '',
    segundos: ''
  }

  if (result.diaSemana === 'segunda' || result.diaSemana === 'terça' || result.diaSemana === 'quarta' || result.diaSemana === 'quinta' || result.diaSemana === 'sexta') {
    result.diaSemana = result.diaSemana + '-feira'
  }

  result.diaSemana = result.diaSemana.toUpperCase();

  let hr = getHours(date);
  if (hr < 10) {
    result.hora = '0' + hr
  } else {
    result.hora = '' + hr
  }

  let min = getMinutes(date)
  if (min < 10) {
    result.minutos = '0' + min
  } else {
    result.minutos = '' + min
  }

  let seg = getSeconds(date)

  if (seg < 10) {
    result.segundos = '0' + seg
  } else {
    result.segundos = '' + seg
  }

  return result;
}

export const MyDate = () => {
  var date = new Date();
  var result = {
    diaSemana: format(date, "EEEE", { locale: ptBR }),
    dia: format(date, "dd", { locale: ptBR }),
    mes: format(date, "MMMM", { locale: ptBR }),
    ano: format(date, "yyyy", { locale: ptBR }),
  }

  if (result.diaSemana === 'segunda' || result.diaSemana === 'terça' || result.diaSemana === 'quarta' || result.diaSemana === 'quinta' || result.diaSemana === 'sexta') {
    result.diaSemana = result.diaSemana + '-feira'
  }

  return result;
}

export const getDevice = () => {
  if (navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
    || isSafari
  ) {
    return true; // está utilizando celular
  }
  else {
    return false; // não é celular
  }
}

export function validateEmail(email: string) {
  let regex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return regex.test(email);
}

/** Mês/Ano dtIncial dtFinal */
export const getMonthYear = (local: any) => {
  const { diaIniMes } = GetSessionUser();
  var months = [];
  var dt = new Date();
  var dia = getDate(dt);
  var diaParam = parseInt(diaIniMes, 10) + 1;
  var ind = 0;
  if (dia < diaParam) ind = 1;
  for (var i = 0; i < 12; i++) {
    var mesAno = subMonths(dt, i);
    months.push(
      {
        "id": i,
        "ind": ind,
        "monthYear": format(mesAno, "MMM-yyyy", { locale: ptBR }),
        "dtInicial": startOfMonth(mesAno),
        "dtFinal": i === 0 ? dt : endOfMonth(mesAno)
      }
    )
  }
  return months;
}


export function primeiroEUltimoDia(data: Dayjs | null): { primeiroDia: Dayjs; ultimoDia: Dayjs } | null {
  if (!data) return null; // Caso a data seja nula, retorna null
  const ano = data.year(); // Obtém o ano
  const mes = data.month() + 1; // Obtém o mês (0-indexado, então somamos 1)
  // Primeiro dia do mês
  const primeiroDia: Dayjs = dayjs(new Date(ano, mes - 1, 1));
  // Último dia do mês
  const ultimoDia: Dayjs = dayjs(new Date(ano, mes, 0)); // Dia 0 do próximo mês retorna o último dia do mês atual
  return { primeiroDia, ultimoDia };
}

export function getSaldacao(locale: any) {
  let h = new Date().getHours();
  if (locale === 'br') {
    return (h <= 5) ? 'Boa madrugada, ' :
      (h < 12) ? 'Bom dia, ' :
        (h < 18) ? 'Boa tarde, ' :
          'Boa noite, ';
  } else if (locale === 'en') {
    return (h <= 5) ? 'Good morning, ' :
      (h < 12) ? 'Good morning, ' :
        (h < 18) ? 'Good afternoon, ' :
          'Good evening,';
  } else {
    return (h <= 5)? 'Buen día, ':
    (h<12)? 'Buen día, ' :
      (h < 18)? 'Buenas tardes, ' :
        'Buenas noches, ';
  }
};

